import { render } from "./dashboard-component.vue?vue&type=template&id=4fd59970&scoped=true"
import script from "./dashboard-component.vue?vue&type=script&lang=js"
export * from "./dashboard-component.vue?vue&type=script&lang=js"

import "./dashboard-component.vue?vue&type=style&index=0&id=4fd59970&scoped=true&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd59970"]])

export default __exports__